import Section from './PicturesBlock'
import isEmpty from './PicturesIsEmpty'

export default { isEmpty, Section }
